var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFields(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3974_5185)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33175 0.249582C8.50546 0.0758722 8.74571 -0.0143993 8.99099 0.00187473L14.8164 0.390204C15.2422 0.418616 15.5814 0.757764 15.6098 1.18368L15.9981 7.00907C16.0145 7.25417 15.9242 7.4945 15.7504 7.66821L7.66811 15.7505C7.33544 16.0832 6.79588 16.0832 6.4632 15.7505L0.249573 9.53676C-0.083191 9.20409 -0.083191 8.66453 0.249573 8.33185L8.33175 0.249582ZM14.7596 1.24041L8.93425 0.852081L0.851983 8.93435L7.0657 15.1481L15.148 7.0658L14.7596 1.24041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6719 5.26599C11.0047 5.59875 11.5441 5.59875 11.8768 5.26599C12.2096 4.93323 12.2096 4.39376 11.8768 4.06108C11.5441 3.72832 11.0047 3.72832 10.6719 4.06108C10.3391 4.39384 10.3391 4.93332 10.6719 5.26599ZM10.0694 5.86849C10.7349 6.53402 11.8139 6.53402 12.4793 5.86849C13.1447 5.20305 13.1447 4.12411 12.4793 3.45858C11.8138 2.79314 10.7348 2.79314 10.0694 3.45858C9.40395 4.12411 9.40395 5.20305 10.0694 5.86849Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3974_5185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFields);
export default __webpack_public_path__ + "static/media/fields.5e7649518844fa0cfe54bbd91bbfab43.svg";
export { ForwardRef as ReactComponent };